import React, { useEffect, useRef } from 'react';
import { Image, ScrollView, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import styles from './pronunciation.style';
import { useColors } from '../../../hooks';
import { useActivityContext } from '../../../hooks/use-activity.context';
import { useScroll } from '../../../hooks/use-scroll';
import { SoundProvider } from '../../../hooks/use-sound-context';
import trueBeginnerStr from '../../../utils/true-beginner-str';
import { AudioPlayerWithContext } from '../../audio-player/audio-player-with-context';
import { ContinueButton } from '../../continue-button/continue-button';
import { IconAudioRecorder } from '../../icon-audio-recorder/icon-audio-recorder';
import { Instruction } from '../../instruction/instruction.component';
import { ThemedView } from '../../themed-view';
import { TranslatableText } from '../../translatable-text/translatable-text';
import { Card } from '../card/card';

export function Pronunciation() {
  const {
    currentActivity: activity,
    currentStep,
    isCurrentStepComplete: isStepCompleted,
    goNext: goNextStep,
    completeCurrentStep: completeStep,
    currentStepIndex,
  } = useActivityContext();

  const scrollRef = useRef<ScrollView>(null);
  const { scrollToTop, scrollToEnd } = useScroll(scrollRef);
  const colors = useColors();

  useEffect(() => {
    if (isStepCompleted) {
      scrollToEnd();
    } else {
      scrollToTop();
    }
  }, [isStepCompleted, scrollToEnd, scrollToTop]);

  return (
    <>
      <SoundProvider url={currentStep?.audio}>
        <ScrollView
          ref={scrollRef}
          style={styles.section}
          contentContainerStyle={styles.container}
        >
          <SafeAreaView edges={['bottom']}>
            <Instruction
              text={trueBeginnerStr(
                activity,
                'instructions',
                activity.trueBeginner
              )}
            />
            {!!currentStep?.image && (
              <Image
                style={styles.image}
                source={{ uri: currentStep?.image }}
              />
            )}

            <ThemedView style={[styles.view]}>
              <AudioPlayerWithContext
                barContainerColor={colors.primaryOpacity}
                inactiveColor={colors.onPrimary}
                activeColor={colors.onPrimary}
              />
            </ThemedView>

            <View style={styles.floatView}>
              <Card containerStyle={styles.card}>
                <TranslatableText
                  style={styles.card}
                  translation={currentStep?.textTranslation}
                  isMarkdown
                  isHtml
                >
                  {currentStep?.text}
                </TranslatableText>
              </Card>
            </View>

            <View style={styles.recorderContainer}>
              <IconAudioRecorder
                key={currentStepIndex}
                index={currentStepIndex}
                color="onPrimary"
                fontSize="medium"
                isRecorded={completeStep}
              />
            </View>
          </SafeAreaView>
        </ScrollView>
        {isStepCompleted && <ContinueButton onPress={goNextStep} />}
      </SoundProvider>
    </>
  );
}
